import { FloatingPortal, useDismiss, useFloating, useInteractions } from "@floating-ui/react";
import { ClickAwayComponent, TextInput } from "components/common";
import { useState } from "react";
import { formatNumberWithCommas } from "utils";

interface ContingencyProps {
  percent: number;
  flatValue: number;
  updatePercent: (p: number) => void;
  onClose: () => void;
  locked: boolean;
}

export const ContingencyAdd: React.FC<ContingencyProps> = ({
  percent,
  updatePercent,
  flatValue,
  onClose,
  locked,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: (open: boolean) => {
      setIsOpen(open);
      if (!open) {
        onClose();
      }
    },
    placement: "top",
  });

  const dismiss = useDismiss(context);

  const { getReferenceProps, getFloatingProps } = useInteractions([dismiss]);

  return (
    <ClickAwayComponent onClickAway={() => setIsOpen(false)}>
      <div className="relative">
        <div className="flex justify-between items-center">
          <div
            className="bg-muted px-2 cursor-pointer"
            onClick={() => {
              setIsOpen(!isOpen);
            }}
            ref={refs.setReference}
            {...getReferenceProps()}
          >
            {percent}%
          </div>
          <div>{formatNumberWithCommas(flatValue)}</div>
        </div>
        {isOpen && (
          <FloatingPortal>
            {!locked ? (
              <div
                id="dropdown"
                className="absolute mt-1 -top-16 w-32 max-h-32 shadow-dropdowns backdrop-blur-md bg-popover rounded-md z-[50] cursor-pointer text-sm"
                ref={refs.setFloating}
                style={floatingStyles}
                {...getFloatingProps()}
              >
                <div className="py-2 bg-muted">
                  <div className="mb-2 text-regular-2">% Amount (0-20)</div>
                  <div className="mx-1 bg-muted">
                    <TextInput
                      normal
                      withOutLabel
                      handleChange={(e) => {
                        if (Number(e) < 21 && Number(e) >= 0) {
                          updatePercent(Number(e));
                        }
                      }}
                      value={percent}
                      name="contingency"
                      type="text"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div
                ref={refs.setFloating}
                style={floatingStyles}
                {...getFloatingProps()}
                className="mb-2 border border-border bg-muted px-4 py-2 text-sm text-foreground"
              >
                Contingency is locked and cannot be edited.
              </div>
            )}
          </FloatingPortal>
        )}
      </div>
    </ClickAwayComponent>
  );
};
